/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type {
  UseMutationOptions,
  UseMutationResult,
  QueryClient,
} from "@tanstack/react-query"
import { mutationOptions, useMutation } from "@tanstack/react-query"

import fetch from "~/backend/axiosClient"
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
  ResponseConfig,
} from "~/backend/axiosClient"

import type {
  UpdateMappingElementMutationRequest,
  UpdateMappingElementMutationResponse,
} from "../types/UpdateMappingElement.ts"

export const updateMappingElementMutationKey = () =>
  [{ url: "/v1/client-settings/update-mapping-element" }] as const

export type UpdateMappingElementMutationKey = ReturnType<
  typeof updateMappingElementMutationKey
>

/**
 * @description Update a mapping element
 * {@link /v1/client-settings/update-mapping-element}
 */
export async function updateMappingElement(
  data: UpdateMappingElementMutationRequest,
  config: Partial<RequestConfig<UpdateMappingElementMutationRequest>> & {
    client?: Client
  } = {}
) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<
    UpdateMappingElementMutationResponse,
    ResponseErrorConfig<Error>,
    UpdateMappingElementMutationRequest
  >({
    method: "POST",
    url: `/v1/client-settings/update-mapping-element`,
    data: requestData,
    ...requestConfig,
  })
  return res
}

export function updateMappingElementMutationOptions<TContext = unknown>(
  config: Partial<RequestConfig<UpdateMappingElementMutationRequest>> & {
    client?: Client
  } = {}
) {
  const mutationKey = updateMappingElementMutationKey()
  return mutationOptions<
    ResponseConfig<UpdateMappingElementMutationResponse>,
    ResponseErrorConfig<Error>,
    { data: UpdateMappingElementMutationRequest },
    TContext
  >({
    mutationKey,
    mutationFn: async ({ data }) => {
      return updateMappingElement(data, config)
    },
  })
}

/**
 * @description Update a mapping element
 * {@link /v1/client-settings/update-mapping-element}
 */
export function useUpdateMappingElement<TContext>(
  options: {
    mutation?: UseMutationOptions<
      ResponseConfig<UpdateMappingElementMutationResponse>,
      ResponseErrorConfig<Error>,
      { data: UpdateMappingElementMutationRequest },
      TContext
    > & { client?: QueryClient }
    client?: Partial<RequestConfig<UpdateMappingElementMutationRequest>> & {
      client?: Client
    }
  } = {}
) {
  const { mutation = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...mutationOptions } = mutation
  const mutationKey =
    mutationOptions.mutationKey ?? updateMappingElementMutationKey()

  const baseOptions = updateMappingElementMutationOptions(
    config
  ) as UseMutationOptions<
    ResponseConfig<UpdateMappingElementMutationResponse>,
    ResponseErrorConfig<Error>,
    { data: UpdateMappingElementMutationRequest },
    TContext
  >

  return useMutation<
    ResponseConfig<UpdateMappingElementMutationResponse>,
    ResponseErrorConfig<Error>,
    { data: UpdateMappingElementMutationRequest },
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient
  ) as UseMutationResult<
    ResponseConfig<UpdateMappingElementMutationResponse>,
    ResponseErrorConfig<Error>,
    { data: UpdateMappingElementMutationRequest },
    TContext
  >
}
